"use strict";import{TabsOverflow as e}from"./src/TabsOverflow.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-tabs-overflow",e);
//# sourceMappingURL=sp-tabs-overflow.js.map
